import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import { VerificationType } from 'modules/shared/models/record.models';
import { RiskAssessmentActionTypes } from 'store/actions/risk-assessment.actions';
var initialState = {
    approvalStatuses: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    riskReports: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    ocrResults: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    faceResults: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    ocrConclusions: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    faceConclusions: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    latestOcrConclusions: null,
    latestFaceConclusions: null,
    loading: [],
    err: []
};
export function reducer(state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case RiskAssessmentActionTypes.GET_APPROVAL_STATUS_SUCCESS: {
            return tslib_1.__assign({}, state, { approvalStatuses: action.payload, loading: clearLoading(state, RiskAssessmentActionTypes.GET_APPROVAL_STATUS), err: state.err.filter(function (item) {
                    return item.action !== RiskAssessmentActionTypes.GET_APPROVAL_STATUS;
                }) });
        }
        case RiskAssessmentActionTypes.GET_APPROVAL_STATUS_FAILURE: {
            return tslib_1.__assign({}, state, { approvalStatuses: null, loading: clearLoading(state, RiskAssessmentActionTypes.GET_APPROVAL_STATUS), err: state.err.concat([{
                        action: RiskAssessmentActionTypes.GET_APPROVAL_STATUS,
                        detail: action.payload
                    }]) });
        }
        case RiskAssessmentActionTypes.GET_REPORTS_SUCCESS: {
            return tslib_1.__assign({}, state, { riskReports: action.payload, loading: clearLoading(state, RiskAssessmentActionTypes.GET_REPORTS), err: state.err.filter(function (item) {
                    return item.action !== RiskAssessmentActionTypes.GET_REPORTS;
                }) });
        }
        case RiskAssessmentActionTypes.GET_REPORTS_FAILURE: {
            return tslib_1.__assign({}, state, { riskReports: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                }, loading: clearLoading(state, RiskAssessmentActionTypes.GET_REPORTS), err: state.err.concat([{
                        action: RiskAssessmentActionTypes.GET_REPORTS,
                        detail: action.payload
                    }]) });
        }
        case RiskAssessmentActionTypes.CREATE_RISK_REPORT_SUCCESS:
        case RiskAssessmentActionTypes.UPDATE_REPORT: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, RiskAssessmentActionTypes.CREATE_RISK_REPORT), riskReports: tslib_1.__assign({}, state.riskReports, { results: [action.payload].concat(state.riskReports.results) }) });
        }
        case RiskAssessmentActionTypes.GET_OCR_RESULTS_SUCCESS: {
            return tslib_1.__assign({}, state, { ocrResults: action.payload, loading: clearLoading(state, RiskAssessmentActionTypes.GET_OCR_RESULTS), err: state.err.filter(function (item) {
                    return item.action !== RiskAssessmentActionTypes.GET_OCR_RESULTS;
                }) });
        }
        case RiskAssessmentActionTypes.GET_OCR_RESULTS_FAILURE: {
            return tslib_1.__assign({}, state, { ocrResults: null, loading: clearLoading(state, RiskAssessmentActionTypes.GET_OCR_RESULTS), err: state.err.concat([{
                        action: RiskAssessmentActionTypes.GET_OCR_RESULTS,
                        detail: action.payload
                    }]) });
        }
        case RiskAssessmentActionTypes.GET_FACE_RESULTS_SUCCESS: {
            return tslib_1.__assign({}, state, { faceResults: action.payload, loading: clearLoading(state, RiskAssessmentActionTypes.GET_FACE_RESULTS), err: state.err.filter(function (item) {
                    return item.action !== RiskAssessmentActionTypes.GET_FACE_RESULTS;
                }) });
        }
        case RiskAssessmentActionTypes.GET_FACE_RESULTS_FAILURE: {
            return tslib_1.__assign({}, state, { faceResults: null, loading: clearLoading(state, RiskAssessmentActionTypes.GET_FACE_RESULTS), err: state.err.concat([{
                        action: RiskAssessmentActionTypes.GET_FACE_RESULTS,
                        detail: action.payload
                    }]) });
        }
        case RiskAssessmentActionTypes.GET_OCR_CONCLUSIONS_SUCCESS: {
            return tslib_1.__assign({}, state, { ocrConclusions: action.payload, loading: clearLoading(state, RiskAssessmentActionTypes.GET_CONCLUSIONS), err: state.err.filter(function (item) {
                    return item.action !== RiskAssessmentActionTypes.GET_CONCLUSIONS;
                }) });
        }
        case RiskAssessmentActionTypes.GET_FACE_CONCLUSIONS_SUCCESS: {
            return tslib_1.__assign({}, state, { faceConclusions: action.payload, loading: clearLoading(state, RiskAssessmentActionTypes.GET_CONCLUSIONS), err: state.err.filter(function (item) {
                    return item.action !== RiskAssessmentActionTypes.GET_CONCLUSIONS;
                }) });
        }
        case RiskAssessmentActionTypes.GET_CONCLUSIONS_FAILURE: {
            return tslib_1.__assign({}, state, { faceConclusions: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                }, ocrConclusions: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                }, loading: clearLoading(state, RiskAssessmentActionTypes.GET_CONCLUSIONS), err: state.err.concat([{
                        action: RiskAssessmentActionTypes.GET_CONCLUSIONS,
                        detail: action.payload
                    }]) });
        }
        case RiskAssessmentActionTypes.GET_LATEST_OCR_CONCLUSIONS_SUCCESS: {
            return tslib_1.__assign({}, state, { latestOcrConclusions: action.payload, loading: clearLoading(state, RiskAssessmentActionTypes.GET_LATEST_OCR_CONCLUSIONS), err: state.err.filter(function (item) {
                    return item.action !== RiskAssessmentActionTypes.GET_LATEST_OCR_CONCLUSIONS;
                }) });
        }
        case RiskAssessmentActionTypes.GET_LATEST_OCR_CONCLUSIONS_FAILURE: {
            return tslib_1.__assign({}, state, { latestOcrConclusions: null, loading: clearLoading(state, RiskAssessmentActionTypes.GET_LATEST_OCR_CONCLUSIONS), err: state.err.concat([{
                        action: RiskAssessmentActionTypes.GET_LATEST_OCR_CONCLUSIONS,
                        detail: action.payload
                    }]) });
        }
        case RiskAssessmentActionTypes.GET_LATEST_FACE_CONCLUSIONS_SUCCESS: {
            return tslib_1.__assign({}, state, { latestFaceConclusions: action.payload, loading: clearLoading(state, RiskAssessmentActionTypes.GET_LATEST_FACE_CONCLUSIONS), err: state.err.filter(function (item) {
                    return item.action !== RiskAssessmentActionTypes.GET_LATEST_FACE_CONCLUSIONS;
                }) });
        }
        case RiskAssessmentActionTypes.GET_LATEST_FACE_CONCLUSIONS_FAILURE: {
            return tslib_1.__assign({}, state, { latestFaceConclusions: null, loading: clearLoading(state, RiskAssessmentActionTypes.GET_LATEST_FACE_CONCLUSIONS), err: state.err.concat([{
                        action: RiskAssessmentActionTypes.GET_LATEST_FACE_CONCLUSIONS,
                        detail: action.payload
                    }]) });
        }
        case RiskAssessmentActionTypes.CREATE_SCREENING_CONCLUSION_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, RiskAssessmentActionTypes.CREATE_SCREENING_CONCLUSION), err: state.err.filter(function (item) {
                    return item.action !== RiskAssessmentActionTypes.CREATE_SCREENING_CONCLUSION;
                }) });
        }
        case RiskAssessmentActionTypes.CREATE_SCREENING_CONCLUSION_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, RiskAssessmentActionTypes.CREATE_SCREENING_CONCLUSION), err: state.err.concat([{
                        action: RiskAssessmentActionTypes.CREATE_SCREENING_CONCLUSION,
                        detail: action.payload
                    }]) });
        }
        case RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS_SUCCESS: {
            var newState = tslib_1.__assign({}, state, { latestOcrConclusions: tslib_1.__assign({}, state.latestOcrConclusions, (_a = {}, _a[action.payload.crp] = action.payload, _a)) });
            if (action.payload.verificationType === VerificationType.FACE) {
                newState = tslib_1.__assign({}, state, { latestFaceConclusions: tslib_1.__assign({}, state.latestFaceConclusions, (_b = {}, _b[action.payload.crp] = action.payload, _b)) });
            }
            return tslib_1.__assign({}, newState, { loading: clearLoading(state, RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS), err: state.err.filter(function (item) {
                    return item.action !== RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS;
                }) });
        }
        case RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS), err: state.err.filter(function (item) {
                    return item.action !== RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS;
                }) });
        }
        case RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS), err: state.err.concat([{
                        action: RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS,
                        detail: action.payload
                    }]) });
        }
        case RiskAssessmentActionTypes.CREATE_APPROVAL_STATUS_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, RiskAssessmentActionTypes.CREATE_APPROVAL_STATUS), err: state.err.filter(function (item) {
                    return item.action !== RiskAssessmentActionTypes.CREATE_APPROVAL_STATUS;
                }) });
        }
        case RiskAssessmentActionTypes.CREATE_APPROVAL_STATUS_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, RiskAssessmentActionTypes.CREATE_APPROVAL_STATUS), err: state.err.concat([{
                        action: RiskAssessmentActionTypes.CREATE_APPROVAL_STATUS,
                        detail: action.payload
                    }]) });
        }
        case RiskAssessmentActionTypes.GET_CONCLUSIONS:
        case RiskAssessmentActionTypes.GET_APPROVAL_STATUS:
        case RiskAssessmentActionTypes.GET_REPORTS:
        case RiskAssessmentActionTypes.GET_OCR_RESULTS:
        case RiskAssessmentActionTypes.GET_FACE_RESULTS:
        case RiskAssessmentActionTypes.GET_LATEST_OCR_CONCLUSIONS:
        case RiskAssessmentActionTypes.GET_LATEST_FACE_CONCLUSIONS:
        case RiskAssessmentActionTypes.CREATE_SCREENING_CONCLUSION:
        case RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS:
        case RiskAssessmentActionTypes.CREATE_APPROVAL_STATUS:
        case RiskAssessmentActionTypes.CREATE_RISK_REPORT: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        default: {
            return state;
        }
    }
}
var riskAssessment = function (state) { return state.riskAssessment; };
var ɵ0 = riskAssessment;
var ɵ1 = function (state) { return state.err; }, ɵ2 = function (state) { return state.loading; }, ɵ3 = function (state) { return state.approvalStatuses; }, ɵ4 = function (state) { return state.riskReports; }, ɵ5 = function (state) { return state.riskReports.results.length ? getLatestRiskReport(state.riskReports.results) : null; }, ɵ6 = function (state) { return state.ocrResults; }, ɵ7 = function (state) { return state.faceResults; }, ɵ8 = function (state) { return state.ocrConclusions; }, ɵ9 = function (state) { return state.faceConclusions; }, ɵ10 = function (state) { return state.latestOcrConclusions; }, ɵ11 = function (state) { return state.latestFaceConclusions; };
export var Selectors = {
    getErrors: createSelector(riskAssessment, ɵ1),
    getLoading: createSelector(riskAssessment, ɵ2),
    getApprovalStatus: createSelector(riskAssessment, ɵ3),
    getReports: createSelector(riskAssessment, ɵ4),
    getLatestReport: createSelector(riskAssessment, ɵ5),
    getOcrResults: createSelector(riskAssessment, ɵ6),
    getFaceResults: createSelector(riskAssessment, ɵ7),
    getOcrConclusions: createSelector(riskAssessment, ɵ8),
    getFaceConclusions: createSelector(riskAssessment, ɵ9),
    getLatestOcrConclusions: createSelector(riskAssessment, ɵ10),
    getLatestFaceConclusions: createSelector(riskAssessment, ɵ11),
};
function getLatestRiskReport(riskReportList) {
    riskReportList.sort(function (reportA, reportB) {
        if (reportA.id > reportB.id) {
            return -1;
        }
        else if (reportB.id > reportA.id) {
            return 1;
        }
        return 0;
    });
    return riskReportList[0];
}
function clearLoading(authState, action) {
    return authState.loading.filter(function (loadingMarker) { return loadingMarker !== action; });
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11 };
